<template>

<Transition name="slide">

    <div v-if="open"
        class="right-0 top-0 h-screen overflow-y-auto w-80 bg-blue border-l border-blue-70 text-white font-bold px-5 pt-3 z-20"
        :class="classes"
    >

        <div class="flex justify-between w-full">
            <span
                class="text-2xl"
            >
                Main Menu
            </span>

            <input-button @onClick="onCloseClick" style-type="none">
                <icon-cross class="h-6 w-6"/>
            </input-button>
        </div>
        <ul class="list-none mt-1">
            <li class="my-6"><static-search-link to="/">Home</static-search-link></li>
            <li class="my-6"><static-search-link to="/contact-us/articles/about-us.htm">About Agency Central</static-search-link></li>
            <li class="my-6"><static-search-link to="/howtouse/how-to-use.htm">How to use Agency Central</static-search-link></li>
            <li class="my-6"><static-search-link to="/contactus/index.html">Contact Agency Central</static-search-link></li>
            <li class="my-6"><static-search-link to="/agencyarea/index.html">Advertise With Us</static-search-link></li>
            <li class="my-6"><static-search-link to="/contact-us/articles/privacy-policy.htm">Privacy Policy</static-search-link></li>
            <li class="my-6"><static-search-link to="/search-for-agencies">Search for Agencies</static-search-link></li>
        </ul>
    </div>
</Transition>

</template>

<script>
import InputButton from "Components/InputButton.vue";
import IconCross from "Components/Icons/IconCross";
import StaticSearchLink from "../StaticSearchLink.vue";

export default {
    name: "SideBar",
    components: {IconCross, InputButton, StaticSearchLink },
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes() {
            return {
                "fixed": this.open,
                "hidden": !this.open
            };
        }
    },
    methods: {
        onCloseClick() {
            this.$emit('onCloseClick');
        }
    }
}
</script>
